import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=08e1b712&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e1b712')) {
      api.createRecord('08e1b712', component.options)
    } else {
      api.reload('08e1b712', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=08e1b712&", function () {
      api.rerender('08e1b712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20obWn0Xya0Tn/JS/videoIframe.vue"
export default component.exports